import { render } from "./waitingDrivers.vue?vue&type=template&id=652b784f&scoped=true"
import script from "./waitingDrivers.vue?vue&type=script&lang=js"
export * from "./waitingDrivers.vue?vue&type=script&lang=js"

import "./waitingDrivers.vue?vue&type=style&index=0&id=652b784f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652b784f"]])

export default __exports__